import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
`



// WEBPACK FOOTER //
// ./src/components/App/styles/App.styles.js